import { ElementRef, ChangeDetectorRef, DestroyRef, inject } from '@angular/core';
import { ScreenService, UiScreenServiceModule } from '../screen-service';
import { takeWhileAlive } from '@core/frontend-shared/utils';
import * as i0 from "@angular/core";
import * as i1 from "../screen-service";
const _c0 = ["*"];
export let UiInputGroupAddonDirective = /*#__PURE__*/(() => {
  class UiInputGroupAddonDirective {
    constructor() {
      this.addon = true;
      this.isCheckbox = false;
      this.isRadiobutton = false;
    }
    static {
      this.ɵfac = function UiInputGroupAddonDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || UiInputGroupAddonDirective)();
      };
    }
    static {
      this.ɵdir = /*@__PURE__*/i0.ɵɵdefineDirective({
        type: UiInputGroupAddonDirective,
        selectors: [["", "uiInputGroupAddon", ""]],
        hostVars: 4,
        hostBindings: function UiInputGroupAddonDirective_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵclassProp("p-input-group-addon", ctx.addon)("p-input-group-addon-checkbox", ctx.isRadiobutton);
          }
        }
      });
    }
  }
  return UiInputGroupAddonDirective;
})();
export let UiInputGroupComponent = /*#__PURE__*/(() => {
  class UiInputGroupComponent {
    constructor(screen, cd, el) {
      this.screen = screen;
      this.cd = cd;
      this.el = el;
      this.destroyRef = inject(DestroyRef);
      this.group = true;
      this.rounded = false;
      this.margin = false;
      /**
       * Main difficulty of styling input-group:
       * in some situations we want the group to fill 100% width, so "main" group elements must stretch.
       * in other situations it shout behave different, and the group should only be as wide as needed.
       * For that reason there's the stretchInputs input to allow for better control.
       */
      this.stretchInputs = false;
      this.breakpoint = -1;
      this.useMobileLayout = false;
    }
    ngOnInit() {
      if (this.breakpoint > 0) {
        this.screen.windowWidth$.pipe(takeWhileAlive(this.destroyRef)).subscribe(val => {
          const newState = val <= this.breakpoint;
          if (newState !== this.useMobileLayout) {
            this.useMobileLayout = newState;
            this.cd.markForCheck();
          }
        });
      }
    }
    static {
      this.ɵfac = function UiInputGroupComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || UiInputGroupComponent)(i0.ɵɵdirectiveInject(i1.ScreenService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef));
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: UiInputGroupComponent,
        selectors: [["ui-input-group"]],
        hostVars: 10,
        hostBindings: function UiInputGroupComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵclassProp("p-input-group", ctx.group)("rounded", ctx.rounded)("margin", ctx.margin)("stretch-inputs", ctx.stretchInputs)("mobile-layout", ctx.useMobileLayout);
          }
        },
        inputs: {
          rounded: "rounded",
          margin: "margin",
          stretchInputs: "stretchInputs",
          breakpoint: "breakpoint"
        },
        ngContentSelectors: _c0,
        decls: 1,
        vars: 0,
        template: function UiInputGroupComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
          }
        },
        dependencies: [UiScreenServiceModule],
        styles: [".p-input-group[_nghost-%COMP%]{--inputGroupElementHeight: var(--inputHeight);--inputGroupElementPadding: var(--inputPadding);--inputGroupBorderRadius:var(--inputBorderRadius)}.p-input-group[_nghost-%COMP%]{display:flex;max-width:100%;border-radius:var(--inputGroupBorderRadius)}.p-input-group[_nghost-%COMP%] >   .p-input-group-addon{height:var(--inputGroupElementHeight);padding:var(--inputGroupElementPadding);min-width:2em;display:flex;flex:0;flex:none;width:min-content;align-items:center}.p-input-group[_nghost-%COMP%] >   .p-input-group-addon.p-input-group-addon-checkbox{position:relative}.p-input-group[_nghost-%COMP%] >   .p-input-group-addon.p-input-group-addon-checkbox .p-checkbox{position:absolute;top:50%;left:50%;margin-left:-10px;margin-top:-10px}.p-input-group[_nghost-%COMP%] >   .p-input-group-addon.p-input-group-addon-radiobutton{position:relative}.p-input-group[_nghost-%COMP%] >   .p-input-group-addon.p-input-group-addon-radiobutton .p-radiobutton{position:absolute;top:50%;left:50%;margin-left:-10px;margin-top:-10px}.p-input-group[_nghost-%COMP%]     .ui-button{height:var(--inputGroupElementHeight);display:inline-flex;align-items:center;justify-content:center;padding:0!important}.p-input-group[_nghost-%COMP%]     .ui-button .ui-button-content{padding:var(--inputGroupElementPadding);padding-top:0;padding-bottom:0}.p-input-group[_nghost-%COMP%]     .ui-button+.ui-button{border-left:0}.p-input-group[_nghost-%COMP%]     .p-input-text, .p-input-group[_nghost-%COMP%]     .p-dropdown{height:100%;height:var(--inputGroupElementHeight)}.p-input-group[_nghost-%COMP%]     ui-field-wrapper{margin:0!important}.p-input-group[_nghost-%COMP%]     .p-input-text:not(:last-child), .p-input-group[_nghost-%COMP%]     ui-input-dropdown:not(:last-child)>.p-dropdown{border-right:0 none}.p-input-group.mobile-layout[_nghost-%COMP%]{display:flex;flex-direction:column}.p-input-group[_nghost-%COMP%]:not(.mobile-layout)    >*{margin:0;--borderLeftRadius:0!important;--borderRightRadius:0!important}.p-input-group[_nghost-%COMP%]:not(.mobile-layout)    >*:first-child{--borderLeftRadius:var(--inputGroupBorderRadius)!important}.p-input-group[_nghost-%COMP%]:not(.mobile-layout)    >*:last-child{--borderRightRadius:var(--inputGroupBorderRadius)!important}.p-input-group.mobile-layout[_nghost-%COMP%]    >*{margin:0;--borderLeftRadius:var(--inputBorderRadius)!important;--borderRightRadius:var(--inputBorderRadius)!important}.stretch-inputs[_nghost-%COMP%] >*{display:flex;border-radius:0;width:100%;flex:1;min-width:0}.margin[_nghost-%COMP%]{margin:30px 0}.rounded[_nghost-%COMP%]{--inputGroupBorderRadius: var(--roundedButtonBorderRadius)}.rounded[_nghost-%COMP%]     .ui-button-icon-only:first-child{padding-left:6px;padding-right:4px}.rounded[_nghost-%COMP%]     .ui-button-icon-only:last-child{padding-left:4px;padding-right:6px}"],
        changeDetection: 0
      });
    }
  }
  return UiInputGroupComponent;
})();